import { render, staticRenderFns } from "./core-update-logs.vue?vue&type=template&id=0aa40bb6&scoped=true&"
import script from "./core-update-logs.vue?vue&type=script&lang=js&"
export * from "./core-update-logs.vue?vue&type=script&lang=js&"
import style0 from "./core-update-logs.vue?vue&type=style&index=0&id=0aa40bb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa40bb6",
  null
  
)

export default component.exports